const hostITD = window.location.host==='localhost:3103' || window.location.host==='localhost' ?'192.168.200.10/mejorservicio.link/index.php':window.location.host;
const Config = {
    dirroot: window.location.protocol+'//'+hostITD,
    apiGateway: window.location.protocol+'//'+hostITD+'/webapi',
}

export default Config;